export const maranui = [-41.33040394971311, 174.79337096214297]
export const factory = [-41.31516342821837, 174.7806090116501]
export const factoryAlley = [-41.31540920637566, 174.7808289527893]
export const factoryInside = [-41.31490153244073, 174.78056609630588]
export const factoryStreet = [-41.31521580724762, 174.78027105331424]
export const factoryJunior = [-41.315070757525035, 174.78095233440402]
export const daisysHouse = [-41.304799610824006, 174.76662397384646]
export const tip = [-41.32396654330406, 174.7455042600632]
export const piHouse = [-41.304618269650035, 174.8249459266663]
export const pakNSave = [-41.318886263629736, 174.7961336374283]
export const roadSide = [-41.29983068026112, 174.79104280471805]
